export default __webpack_public_path__ + "static/media/871.10e06fea.png";